<template>
  <div :class="['group list-input', { empty: !monthlyExtras.length }]">
    <!-- Controls -->
    <div class="list-input-controls">
      <span class="text-muted small">{{
        monthlyExtras.length ? "MONTHLY EXTRAS" : "ADD MONTHLY EXTRAS"
      }}</span>
      <b-button
        variant="light"
        class="list-input-btn"
        v-b-tooltip.hover.right="'Add a new monthly extra'"
        @click="add()"
      >
        <font-awesome-icon :icon="['fas', 'plus']" />
      </b-button>
    </div>

    <!-- Monthly Extras -->
    <div v-for="(monthlyExtra, i) in monthlyExtras" :key="i" class="list-input-item">
      <b-form-group label="Count">
        <b-form-input v-model="monthlyExtra.count" type="number" min="0" />
      </b-form-group>

      <b-form-group label="Charge">
        <b-form-input v-model="monthlyExtra.charge" type="number" min="0" />
      </b-form-group>

      <b-form-group label="Description">
        <b-form-input v-model="monthlyExtra.description" />
      </b-form-group>

      <b-dropdown
        variant="link"
        toggle-class="text-decoration-none p-0"
        no-caret
        boundary="viewport"
      >
        <template #button-content>
          <font-awesome-icon :icon="['fas', 'bars']" />
        </template>
        <b-dropdown-item @click="add(monthlyExtra)">Duplicate</b-dropdown-item>
        <b-dropdown-item @click="remove(i)" variant="danger"><font-awesome-icon class="mr-1"  :icon="['fal', 'trash-alt']" /> Remove </b-dropdown-item>
      </b-dropdown>

      <hr v-if="i != monthlyExtras.length - 1" class="divider" />
    </div>
  </div>
</template>

<script>
export default {
  name: "MonthlyExtrasInput",
  model: {
    prop: "monthlyExtras",
    event: "change"
  },
  props: {
    monthlyExtras: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onChange() {
      this.$emit("change", this.monthlyExtras);
    },

    add(monthlyExtra) {
      if (!monthlyExtra) {
        monthlyExtra = {
          description: null,
          charge: null,
          count: null
        };
      } else {
        // Create a new object, we don't want a reference
        monthlyExtra = Object.assign({}, monthlyExtra);
      }
      this.monthlyExtras.push(monthlyExtra);
      this.onChange();
    },

    remove(index) {
      this.$delete(this.monthlyExtras, index);
      this.onChange();
    }
  }
};
</script>
